import { DecimalPipe, PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {

  constructor (private decimalPipe: DecimalPipe) {

  }

  transform(input: any, decimals: string): string {
      let filteredValue = this.decimalPipe.transform(input, decimals);
      return filteredValue ? filteredValue  + '%' : input;
  }


}
